import { AccommodationApiDto as ProductAccommodationApiDto, AccommodationExtraApiDto, AccommodationV2ApiDto } from '@lx/shared/api/models';
import { Amount } from '@lx/shared/data-access/types';
import AccommodationTypeApiDto = AccommodationV2ApiDto.AccommodationTypeEnum;
import BathroomTypeApiDto = AccommodationV2ApiDto.BathroomTypeEnum;
import MealOptionsApiDto = AccommodationV2ApiDto.MealOptionsEnum;

export type Accommodation = AccommodationV2ApiDto;
export type BathroomType = BathroomTypeApiDto;
export const BathroomTypeEnum = BathroomTypeApiDto;
export type MealOption = MealOptionsApiDto;
export const MealOptionEnum = MealOptionsApiDto;
export const OTHER = AccommodationExtraApiDto.TypeEnum.OTHER;

export interface GroupableAccommodation extends Accommodation {
  title?: string;
  groupingKey: string;
  groupedItems: Accommodation[];
}

export interface AccommodationWithOptions {
  groupingKey: string;
  name: string;
  thumbnailSmall: string;
  description: string;
  galleryUrls: Array<string>;
  roomTypes: Set<string>;
  bathroomTypes: Set<BathroomTypeApiDto>;
  mealOptions: Set<MealOptionsApiDto>;
  startingPrice: Amount;
  oldPrice: Amount;
  hasPromotion?: boolean;
  accommodationType: AccommodationTypeApiDto;
  seasonalDisclaimer?: string;
  subjectToAvailability?: boolean;
  company: AccommodationV2ApiDto.CompanyEnum;
  ageMin?: number;
}

export type ProductAccommodation = ProductAccommodationApiDto & { weight?: number };

export function bathroomTypeSorter(a: string, b: string): number {
  if (a === BathroomTypeApiDto.PRIVATE) {
    return -1;
  } else if (b === BathroomTypeApiDto.SHARED) {
    return 1;
  } else {
    return 0;
  }
}

const mealOptionsOrder = {
  [MealOptionEnum.NO_MEALS]: 0,
  [MealOptionEnum.BED_BREAKFAST]: 1,
  [MealOptionEnum.HALF_BOARD]: 2,
  [MealOptionEnum.MEAL_PLAN]: 3,
};

export function mealOptionsSorter(a: string, b: string): number {
  return mealOptionsOrder[a] - mealOptionsOrder[b];
}
